module.exports = __webpack_public_path__ + "img/translate3.5226177c.jpg";